import {
  DEFAULT_PROMOTIONS_PRODUCT_SORT_COLUMN,
  DEFAULT_PROMOTIONS_PRODUCT_SORT_ORDER,
} from "@/core/constants/promotion/promoFilterOptions";
import { TableSortInfoColumnType } from "@ir/ui";

export interface PromotionProductsFilterInfo {
  search: string | null;
  sortColumn: string | null;
  sortOrder: TableSortInfoColumnType["order"] | null;
}

export const getEmptyPromotionProductsFilterInfo = (): PromotionProductsFilterInfo => ({
  search: null,
  sortColumn: DEFAULT_PROMOTIONS_PRODUCT_SORT_COLUMN,
  sortOrder: DEFAULT_PROMOTIONS_PRODUCT_SORT_ORDER,
});

export const isDefaultPromotionProductsFilter = (filterInfo: PromotionProductsFilterInfo): boolean => {
  return Object.entries(filterInfo)
    .filter(([key]) => key !== "sortColumn" && key !== "sortOrder")
    .every(([, value]) => {
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      return value === null || value === "" || value === undefined;
    });
};

export const resolvePromotionProductsSortParams = (
  sortColumn: string | null,
  sortOrder: TableSortInfoColumnType["order"] | null
): { sortColumn: string; sortOrder: TableSortInfoColumnType["order"] } => ({
  sortColumn: sortColumn ?? DEFAULT_PROMOTIONS_PRODUCT_SORT_COLUMN,
  sortOrder: sortOrder ?? DEFAULT_PROMOTIONS_PRODUCT_SORT_ORDER,
});
